import { render, staticRenderFns } from "./step-cost.vue?vue&type=template&id=2ff09b7b"
import script from "./step-cost.vue?vue&type=script&lang=ts"
export * from "./step-cost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports